/** Which address the BE says is missing or incomplete (`CHECKOUT_ADDRESS_INCOMPLETE`). */
export type CheckoutAddressKind = "delivery" | "billing" | "company";

export interface CheckoutError {
  message: string;
  address?: CheckoutAddressKind;
}

interface ApiErrorBody {
  message?: string;
  details?: { address?: CheckoutAddressKind };
}

/**
 * Normalises a failed checkout call (draft order, payment intent) into the
 * message to show and, for address problems, which address to fix.
 */
export function toCheckoutError(err: unknown, fallback: string): CheckoutError {
  const body = (err as { response?: { data?: ApiErrorBody } })?.response?.data;
  return {
    message: body?.message ?? (err as { message?: string })?.message ?? fallback,
    address: body?.details?.address,
  };
}
